import { render, staticRenderFns } from "./LandingReviews.vue?vue&type=template&id=75931af6&scoped=true"
import script from "./LandingReviews.vue?vue&type=script&lang=js"
export * from "./LandingReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75931af6",
  null
  
)

export default component.exports